export const RouteConstants = {
  ROUTE_HOME: '/home' as const,
  ROUTE_LOGIN: '/login' as const,
  ROUTE_LOGOUT: '/logout' as const,
  ROUTE_PUBLIC: '/public' as const,
  ROUTE_SIGNUP: '/signup' as const,
  ROUTE_CHECK: '/check' as const,
  ROUTE_BATCH_CHECK: '/batch-check' as const,
  ROUTE_TEAM: '/team' as const,
  ROUTE_TEAM_CONFIGURE_FEATURES: '/team/configure-features' as const,
  ROUTE_INTEGRATIONS: '/integrations' as const,
  ROUTE_DATA_EXTRACTION: '/data-extraction' as const,
  ROUTE_DASHBOARD_CREATE_RULE: '/dashboard/create-rule' as const,
  ROUTE_DASHBOARD_EDIT_RULE: '/dashboard/edit-rule/:id' as const,
} as const;
